import React from 'react';
import { Link } from "gatsby";
import { useStaticQuery, graphql } from "gatsby";
import { Col, Container } from 'react-bootstrap';
import HtmlParser from 'react-html-parser';
import { useMatch } from "@reach/router"
import ScrollAnimation from 'react-animate-on-scroll';

/**
 * Assets
 */
import './styles/_index.scss';

/**
 * Components
 */
import ContactQueryForm from '@blocks/forms/contact-query';
import GeneralEnquiryForm from '@components/forms/general-enquiry';
import TextColumns from '@components/text-columns/text-columns';
import Breadcrumbs from '@components/breadcrumbs/breadcrumbs';
import ContactBox from '@components/contact-box/contact-box';
import OfficeBox from '@components/office-box/office-box';

const ContactQuery = (props) => {

    //console.log("news", props)
    const data = useStaticQuery(graphql`
        query {
        avatar1: file(relativePath: { eq: "avatar1.png" }) {
            childImageSharp {
                fluid(maxWidth: 78) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        officeImage: file(relativePath: { eq: "office-image.jpg" }) {
            childImageSharp {
                fluid(maxWidth: 768) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        }
    `);
    const match = useMatch('/about/our-people/:item');

    return match ? (
        <empty></empty>
          ) : (
        <div className="contact-query inner-intro breadcrumbs-intro blogs">
            <Breadcrumbs/>  
            <Container>
                <div className={`page page-intro-${props?.Page?.Pagename}`}>                                      
                <h1 className='spacing-bottom-24'>{props.Title}</h1>
                {props.Content &&
                        <div className='text-20'>
                            {HtmlParser(props.Content)}
                        </div>
                }
                </div>
                {/*<ScrollAnimation  animateIn='animate__fadeInUp' animateOnce={true} >             
                <ReactMarkdown rehypePlugins={[rehypeRaw]} children={props.Content}/>
                </ScrollAnimation>*/}
            </Container>
        </div>
    )
}

export default ContactQuery
